<template>
<!-- Site wrapper -->
<div class="wrapper">
  <cabecalho tituloPagina="Notícias" />
  <menuLateral />

  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
      </div><!-- /.container-fluid -->
    </section>
    <!-- Main content -->
  <section class="content">
    <!-- Default box -->
    <div class="card">
      <div class="card-body">
        <div v-if="flagsDeControle.carregandoDados.status" class="d-flex align-items-center">
          <span class="avisoDanger">{{flagsDeControle.carregandoDados.mensagem}}</span>
          <b-spinner class="ml-2" variant="danger"></b-spinner>
        </div>
        <div class="row justify-content-center">
          <div v-if="tabelaSemRegistros" class="col-12 text-center font-italic">
            <span>Nenhum registro encontrado.</span>
          </div>
          <div v-else v-for="(campo) in listaNoticias" :key="campo.id" class="col-12 col-sm-6 col-md-3">
            <div class="card bg-light d-flex flex-fill">
              <div class="card-header titulos-conteudo border-bottom-0">{{campo.title}}</div>
              <div class="card-body pt-0">
                <div class="row">
                  <div class="col-12">
                    <p>
                      <small class="text-muted">{{$date(campo.date).format('DD/MM/YYYY')}}</small>
                      <br/>
                      <small class="text-muted">Publicado por: {{campo.author}}</small>
                    </p>
                  </div>
                  <div class="col 12">
                    <p class="card-text textos" v-html="campo.summary"></p>
                  </div>
                </div>
              </div>
              <div class="card-footer text-right">
                <b-button class="botoes" variant="outline-primary btn-sm mt-2" @click="detalhesNoticia(campo.id)" :disabled="flagsDeControle.carregandoDados.status">Ver</b-button>
              </div>
            </div>
          </div>
        </div>
        <pagination :fonteDeDados="componentePaginacao.fonteDeDados" :disabled="flagsDeControle.carregandoDados.status || tabelaSemRegistros" @navegarNaPaginacao="obterDadosPaginados"/>
      </div>
      <!-- /.card-body -->
    </div>
    <!-- /.card -->
  </section>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</div>
<!-- ./wrapper -->
</template>

<script>
import Noticias from './js'
export default Noticias
</script>

<style scoped>
@import "./scss/noticias.scss";
</style>
